export const validateEmailPrefixFormat = (value, multipleDomains) => {
    let error;
    if (/@/.test(value)) {
        error =
            "Only put the first part of your uni email address here (anything before the “@”-sign)";
        if (multipleDomains) {
            error += ". Next, pick the correct email domain.";
        }
    }

    return error;
};

const validator = selectedTabTitle => values => {
    let errors = {};
    // This validation is a bit of a big old if else tree.
    // We could use something like Yup to make it a bit nicer
    if (!values.firstName) {
        errors.firstName = "Required";
    }
    if (!values.lastName) {
        errors.lastName = "Required";
    }
    if (!values.universityName) {
        errors.universityName = "Required";
    }
    if (!values.personalEmail) {
        errors.personalEmail = "Required";
    }
    if (!values.personalEmailConfirmation) {
        errors.personalEmailConfirmation = "Required";
    }
    if (
        values.personalEmail &&
        // regex to test for a string in email format
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.personalEmail)
    ) {
        errors.personalEmail = "Invalid email address";
    }
    if (values.personalEmail !== values.personalEmailConfirmation) {
        errors.personalEmailConfirmation = "The email addresses do not match";
    }
    if (!values.password) {
        errors.password = "Required";
    } else if (
        // regex to test for a string of 6+ characters containing a number
        !/^(?=.*\d).{6,}$/.test(values.password)
    ) {
        errors.password =
            "Password must be at least six characters and contain a number";
    }
    if (selectedTabTitle === "Recently graduated") {
        // University email only required for graduates if they don't tick
        // the box for "I don' t have access to my uni email"
        if (!values.hasAccessToUniEmail) {
            // Otherwise they're required to provide their personal email
            if (!values.personalEmail) {
                errors.personalEmail = "Required";
            }
        } else {
            if (!values.emailPrefix) {
                errors.emailPrefix = "Required";
            }
            if (!values.emailPrefixConfirmation) {
                errors.emailPrefixConfirmation = "Required";
            }

            let emailPrefixConfirmationError = validateEmailPrefixFormat(
                values.emailPrefixConfirmationError
            );

            let emailPrefixError = validateEmailPrefixFormat(
                values.emailPrefix
            );

            if (values.emailPrefix !== values.emailPrefixConfirmation) {
                errors.emailPrefixConfirmation =
                    "The email addresses do not match";
            }

            if (emailPrefixError) {
                errors.emailPrefix = emailPrefixError;
            }

            if (emailPrefixConfirmationError) {
                errors.emailPrefixConfirmation = emailPrefixConfirmationError;
            }

            if (!values.emailExtension) {
                errors.emailExtension = "Required";
            }
        }
    } else {
        // University email always required for current students
        if (!values.emailPrefix) {
            errors.emailPrefix = "Required";
        }

        if (!values.emailPrefixConfirmation) {
            errors.emailPrefixConfirmation = "Required";
        }

        if (values.emailPrefix !== values.emailPrefixConfirmation) {
            errors.emailPrefixConfirmation = "The email addresses do not match";
        }

        let emailPrefixError = validateEmailPrefixFormat(values.emailPrefix);
        if (emailPrefixError) {
            errors.emailPrefix = emailPrefixError;
        }

        if (!values.emailExtension) {
            errors.emailExtension = "Required";
        }
    }
    return errors;
};

export default validator;
